import Swiper, { Autoplay, EffectFade, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';

function initializeBanner(containerId) {
    const containerSlider = $(containerId);

    const bannerSlider = new Swiper(containerId, {
        modules: [Navigation, EffectFade, Autoplay],
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
        
        autoplay: {
            delay: 7000,
        },
        
    });

    
    
    
    var timeout;
    bannerSlider.on('slideChangeTransitionEnd', function () {
        const activeSlider = containerSlider.find('.swiper-slide-active');
        
        const currentSlideImg = activeSlider.data('img');
        

        if (timeout) {
            clearTimeout(timeout);
        }

        $('.banner-image').attr('src', currentSlideImg);

        console.log(activeSlider.data('color'));

        $('.banner-fill-clip-home').css('color', activeSlider.data('color'));
    });
}

$('.banner-slider').each(function () {
    initializeBanner('#' + $(this).attr('id'));
});
